import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';
import X from '../../public/icons/x.svg';
import useHeaderHeight from '../../lib/useHeaderHeight';
import { AppContext } from '../../provider/AppContextProvider'
import { useUser } from '../../lib/useUser';
import UserSignedIn from '../user/UserSignedIn';
import UserSignedOut from '../user/UserSignedOut';
import UserRegister from '../user/UserRegister';
import { useModalFocus } from '../../lib/useModalFocus';

export type NavigationProps = {
  isCollapsed: boolean,
  isApp?: boolean,
  toggleOverlay?: Function
}

export default function UserComponent(props: NavigationProps) {
  const [register, setRegister] = useState(false)
  const [user, setUser] = useUser()
  const { headerDisabled, subscription } = useContext(AppContext);
  const userNavRef = useRef<HTMLDivElement>(null);

  
  // const { pageId } = React.useContext(AppContext);
  const collapsed = props.isCollapsed;
  
  useModalFocus({ 
    isOpen: !collapsed,
    onClose: () => {
      toggleOverlay();
    },
    modalRef: userNavRef as React.RefObject<HTMLElement>,
  });
  
  const toggleOverlay = () => {
    if (props.toggleOverlay) {
      props.toggleOverlay()
    }
  }

  const toggleRegister = useCallback(() => {
    setRegister(!register)
  }, [register])

  const [documentHeight, setDocumentHeight] = useState<number | null>(null)
  const getHeights = () => {
    setDocumentHeight(window.innerHeight)
  }

  useEffect(() => {
    getHeights()
    window.addEventListener('resize', getHeights);
  }, [])

  return <div className={`user-nav ${collapsed ? 'collapsed' : ''}`} style={{ top: '0', height: (documentHeight) + 'px' }} ref={userNavRef}>
      {!register &&
        <div className="user pb-10">
          { !headerDisabled && props.isApp != true &&
            <React.Fragment>
              <button className="user__close" aria-label="Schließen" onClick={() => {toggleOverlay()}}>
                <X />
              </button>
            </React.Fragment>
          }
          {!user && 
            <UserSignedOut toggleRegister={toggleRegister} user={user} setUser={setUser} showCustomize={true}/>
          }
          {user &&
            <UserSignedIn user={user} setUser={setUser} />
          }
          {/* {
            <div>
              <div>Pur-Abo-App: {subscription?.purApp ? "Ja" : "Nein" }</div>
              <div>Plus-Abo-App: {subscription?.nnPlusApp ? "Ja" : "Nein" }</div>
              <div>Pur-Abo-App-Valid: {subscription?.purValidUntil }</div>
              <div>Plus-Abo-App-Valid: {subscription?.nnPlusValidUntil }</div>
              <div>Pur-Abo-Web: {subscription?.purWeb ? "Ja" : "Nein" }</div>
              <div>Plus-Abo-Web: {subscription?.nnPlusWeb ? "Ja" : "Nein" }</div>
              <div>Validated: {subscription?.validated ? "Ja" : "Nein" }</div>
            </div>
          } */}
        </div>
      }
      { register &&
        <div className="user pb-10">
          { !headerDisabled && props.isApp != true &&
            <React.Fragment>
              <button className="user__close" aria-label="Schließen" onClick={() => {toggleOverlay(); toggleRegister()}}>
                <X />
              </button>
            </React.Fragment>
          }
          <UserRegister setUser={setUser} toggleOverlay={() => {toggleOverlay(); toggleRegister()}} />
        </div>
      }
    </div>
  
}